namespace advisorop.components.identity {


    class ResetPasswordFormController {
        
        $router;
        public resetPasswordModel: domains.identity.IResetPasswordModel;

        resettingPassword = false;
        passwordResetSuccess = false;

        constructor(private identityService: services.IdentityService) {

            this.resetPasswordModel = new domains.identity.ResetPasswordModel();
            this.resetPasswordModel.password = "";
            this.resetPasswordModel.confirmPassword = "";
        }

        //login method
        resetPassword(): void {
            var r = this.$router;

            this.resettingPassword = true;

            this.identityService.resetPassword(this.resetPasswordModel)
                .then(resp => {
                    toastr.info("You have successfully reset your password.");
                    setTimeout(function () {
                        this.passwordResetSuccess = true;
                        r.parent.navigate(["Login"]);
                    }, 1000);
                    //we are navigating to the dashboard
                    //window.location.href = "/";
                }, resp => toastr.error("Error " + resp.status + ":" + resp.data))
                .finally(() => {
                    this.resettingPassword = false;
                });
        };

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            this.resetPasswordModel.userId = next.params.userId;
            this.resetPasswordModel.code = next.params.code;
        }
    }
    
    class ResetPasswordForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public host: any;

        constructor() {
            this.bindings = {
                $router: '<'
            };
            this.controller = ["identityService", ResetPasswordFormController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/reset-password-form.html';
        }

    }
    angular.module(Constants.APP).component("resetPasswordForm", new ResetPasswordForm());
}
